<script setup>
import { router, Head} from '@inertiajs/vue3';
import { onMounted, reactive, ref } from 'vue';
import JetButton from '@/Jetstream/Button.vue';
import JetAuditorHeader from '@/Jetstream/AuditorHeader.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';
import AuditorFeedbackQuestion from '@/Pages/Auditor/AuditorFeedbackQuestion.vue';


// includes we need to front end locale magic
import { useI18n } from 'vue-i18n';

// Get locale as set in cookie
const { locale, fallbackLocale} = useI18n({ useScope: 'global' });

// Check if in auditor mode
let auditor = false;
let toolkitID = '';
let auditorFeedbackQuestions = [];
let auditorFeedbackAnswers = [];
let auditorSession = [];
let auditorName = '';
if (router.page.props.auditor) {
    auditor = router.page.props.auditor;
    toolkitID = router.page.props.toolkitID;
    auditorSession = router.page.props.auditorSession;
    auditorFeedbackQuestions = router.page.props.auditorFeedbackQuestions;
    auditorFeedbackAnswers = router.page.props.auditorFeedbackAnswers;
    auditorName = auditorSession.auditor_name;
}

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";
const formData = reactive([]);
const completeAuditButton = ref(false);

//Loop through each custom question and build the formData reactive array.
let question_id = 0;
auditorFeedbackQuestions.forEach(function (auditorFeedbackQuestion) {
    formData.push({
        "index_id": question_id,
        "input_type": auditorFeedbackQuestion.type,
        "question_id": auditorFeedbackQuestion.id,
        "toolkit_id": toolkitID,
        "answer": '',
        "required": auditorFeedbackQuestion.required
    });
    auditorFeedbackQuestion["index_id"] = question_id;
    question_id++;
});

let formDataItemQuestionID;
let unansweredRequiredQuestions = false;

// Assign answers
formData.forEach(function (formDataItem) {
    formDataItemQuestionID = formDataItem.question_id;

    auditorFeedbackAnswers.forEach(function (auditorFeedbackAnswer) {
        if ( auditorFeedbackAnswer.auditor_feedback_question_id == formDataItemQuestionID ) {

            if(formDataItem.input_type == 'checkbox') {
                auditorFeedbackAnswer.answer = (auditorFeedbackAnswer.answer == '1' ? 'true' : auditorFeedbackAnswer.answer);
            }

            formDataItem.answer = auditorFeedbackAnswer.answer;

        }
    });
});

const displaySuccessMessage = () => {
    const saveSuccessAlert = document.getElementById('alert-save-success');
    saveSuccessAlert.classList.remove('alert-hidden');
}
const hideSuccessMessage = () => {
    const saveSuccessAlert = document.getElementById('alert-save-success');
    saveSuccessAlert.classList.add('alert-hidden');
}

const displayErrorMessage = () => {
    const saveErrorAlert = document.getElementById('alert-save-error');
    saveErrorAlert.classList.remove('alert-hidden');
}

const hideErrorMessage = () => {
    const saveErrorAlert = document.getElementById('alert-save-error');
    saveErrorAlert.classList.add('alert-hidden');
}

// Check for unanswered questions
formData.forEach(function (formDataItem) {
    if ( formDataItem.answer == '' & formDataItem.required == 1) {
    unansweredRequiredQuestions = true;
    }
});

// This is the function that posts updated questions data to the database
const UpdateAuditorFeedbackQuestions = ($event) => {

formData.forEach(function (formDataItem) {
    delete formDataItem.index_id;
});

router.post(route(urlNamePrefix + 'auditor.auditor-feedback-questions.updateAuditorFeedbackQuestions', { 'subdomain': 'auditor'}),
    {
        formData
    },
    {
        preserveState: true,
        preserveScroll: true,
        onSuccess: function() {
            console.log('Success!');
            displaySuccessMessage();
            hideErrorMessage();
            completeAuditButton.value = true;

        },
        onError: (errors) => {
            console.log('Fail!');
            displayErrorMessage();
            hideSuccessMessage();
        },

    });
}

const completeAudit = ($event) => {
    completeAuditButton.value = false;
}

onMounted(() => {
    if ( unansweredRequiredQuestions == true ) {
        $('#alert-save-info').removeClass('alert-hidden');
    }

    $('#alert-save-info .alert-close').on('click', function (e) {
    e.preventDefault();
        $('#alert-save-info').addClass('alert-hidden');
    });
    $('#alert-save-success .alert-close').on('click', function (e) {
    e.preventDefault();
        $('#alert-save-success').addClass('alert-hidden');
    });
    $('#alert-save-error .alert-close').on('click', function (e) {
    e.preventDefault();
        $('#alert-save-error').addClass('alert-hidden');
    });
});



</script>

<template>

    <AppTheming />

    <Head title="Auditor Feedback Questions" />

    <JetAuditorHeader v-if="organisation != undefined" :programme="programme" :organisation="organisation" />
    <JetAuditorHeader v-else :programme="programme" />

    <div id="content-wrapper" class="bg-gray-200 auditor-content-wrapper">
        <div id="main-content" class="container w-full pt-5 pb-5 mx-auto">

            <div class="sm:pl-10 sm:pr-10">
                <div class="mt-0 text-gray-500">
                    <div class="mt-10 mb-10 form-item-container">

                        <h1 class="dashboard-title">
                            {{ $t('auditor.auditor_questions.auditor_questions_heading', { auditor: auditorName } ) }}
                        </h1>
                        <p class="font-bold">{{ $t('auditor.auditor_questions.auditor_questions_introduction') }}</p>

                        <div id="alert-save-success" class="p-5 mb-5 bg-green-100 rounded alert alert-success alert-hidden">
                            <div class="flex justify-between">
                                <div class="flex space-x-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-4 h-4 text-green-500 fill-current">
                                    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z" /></svg>
                                    <div class="flex-1 text-sm font-medium leading-tight text-green-700">{{ $t('teams.questions.saved') }}</div>
                                </div>
                                <button class="alert-close">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-3 h-3 text-green-600 fill-current">
                                    <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" /></svg>
                                </button>
                            </div>
                        </div>

                        <div id="alert-save-error" class="p-5 mb-5 bg-red-100 rounded alert alert-success alert-hidden">
                            <div class="flex justify-between">
                            <div class="flex space-x-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-4 h-4 text-red-500 fill-current">
                                    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.597 17.954l-4.591-4.55-4.555 4.596-1.405-1.405 4.547-4.592-4.593-4.552 1.405-1.405 4.588 4.543 4.545-4.589 1.416 1.403-4.546 4.587 4.592 4.548-1.403 1.416z" /></svg>
                                    <div class="flex-1 text-sm font-medium leading-tight text-red-700">{{ $t('auditor.auditor_questions.auditor_questions_error_message') }}</div>
                            </div>
                            <button class="alert-close">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-3 h-3 text-red-600 fill-current">
                                <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" /></svg>
                            </button>
                            </div>
                        </div>

                        <div class="">

                            <form @submit.prevent="UpdateAuditorFeedbackQuestions" >
                                <div v-if="auditorFeedbackQuestions.length !== 0">
                                    <AuditorFeedbackQuestion
                                        v-for="auditorFeedbackQuestion in auditorFeedbackQuestions"
                                        :auditorFeedbackQuestion="auditorFeedbackQuestion"
                                        :key="auditorFeedbackQuestion.index_id"
                                        :formData="formData"
                                        :datePicker="datePicker"
                                    />

                                    <div class="flex items-end w-full mt-5">
                                        <JetButton
                                            type="submit"
                                            class="inline-flex items-center px-4 py-2 mr-3 text-xs font-semibold tracking-widest text-white uppercase transition bg-gray-800 border border-transparent rounded-md hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25"
                                            >
                                            {{ $t('auditor.auditor_questions.auditor_questions_submit_feedback') }}
                                        </JetButton>

                                        <a v-if="completeAuditButton == true"
                                            @click="completeAudit"
                                            :href="route(urlNamePrefix+'auditor.auditComplete', { 'subdomain': 'auditor'})"
                                            class="inline-flex items-center px-4 py-2 text-xs font-semibold tracking-widest text-white uppercase transition bg-gray-800 border border-transparent rounded-md hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25"
                                            >
                                            {{ $t('auditor.auditor_questions.complete_audit') }}
                                        </a>
                                    </div>

                                </div>
                            </form>

                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>

</template>
